export default __webpack_public_path__ + "static/media/2.bf79be2f.png";